import { DateTime as DateTime$1 } from "../../DateTime/index.js";
import { UserName } from "../../../modules/Users/shared/UserName.js";
import "react";
import { DinnerTable } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/AuditLogs/AuditLogTable/TableRow.tsx
function AuditLogTableRow({ rowData, showUser }) {
	return /* @__PURE__ */ jsxs(DinnerTable.Row, { children: [
		/* @__PURE__ */ jsx(DinnerTable.Cell, { children: /* @__PURE__ */ jsx(DateTime$1, {
			mode: "datetime",
			timestamp: rowData.date
		}) }),
		showUser && /* @__PURE__ */ jsx(DinnerTable.Cell, { children: rowData.userId ? /* @__PURE__ */ jsx(UserName, { userId: rowData.userId }) : /* @__PURE__ */ jsx("div", {
			className: "text-color-subtle text-xs opacity-50",
			children: "N/A"
		}) }),
		/* @__PURE__ */ jsx(DinnerTable.Cell, { children: /* @__PURE__ */ jsx("div", {
			className: "capitalize",
			children: rowData?.action
		}) }),
		/* @__PURE__ */ jsx(DinnerTable.Cell, { children: /* @__PURE__ */ jsx("div", {
			className: "truncate",
			children: rowData.title
		}) }),
		/* @__PURE__ */ jsx(DinnerTable.Cell, { children: rowData?.device ? /* @__PURE__ */ jsxs("div", {
			className: "w-52",
			children: [
				/* @__PURE__ */ jsx("div", { children: rowData.device?.name }),
				/* @__PURE__ */ jsx("div", {
					className: "text-xs",
					children: rowData.device?.os
				}),
				/* @__PURE__ */ jsx("div", {
					className: "text-color-subtle text-xs capitalize",
					children: rowData.device?.type
				})
			]
		}) : /* @__PURE__ */ jsx("div", {
			className: "text-color-subtle text-xs opacity-50",
			children: "N/A"
		}) })
	] });
}
//#endregion
export { AuditLogTableRow };

//# sourceMappingURL=TableRow.js.map